import React, { useState, useEffect, useRef } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { BarPlot } from '@mui/x-charts/BarChart';
import { LinePlot } from '@mui/x-charts/LineChart';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
import { ChartsLegend } from '@mui/x-charts/ChartsLegend';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// import StormDateDropDown from "../LIDPanel/StormDateDropDown";

// This component produces the graph for subcatchments, where you have both runoff and rainfall to plot
function ResultsChart({ x, y1, y2, y3}) {

    const [showLine, setShowLine] = useState(true);
    const [showBar, setShowBar] = useState(true);

    const firstTimestamp = new Date(x[0]);
    const xAxisData = x.map(timestamp => ((new Date(timestamp) - firstTimestamp) / 3600000)); // Convert timestamps to hours
    
    const dataset = xAxisData.map((time, index) => ({
        time,
        og_runoff: y1[index],
        rainfall: y2[index],
        new_runoff: y3[index]
    }));

    const series = [
        { type: 'line', dataKey: 'og_runoff', color: '#26a6e0' },
        { type: 'line', dataKey: 'new_runoff', color: '#FFA500' },
        { type: 'bar', dataKey: 'rainfall', color: 'rgba(255, 255, 255, 0.5)', yAxisId: 'rightAxis'}
    ];

    return (
        <Box sx={{ width: '100%', height: '500px', displauy: 'flex', alignItems: 'flex-start', overflow: 'hidden', padding: '0px 0px 0px 0px' }}>
            <Box sx={{ marginBottom: '0px', 
                    marginLeft: '20px', 
                    marginTop: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    '& > *': { marginRight: '8px' }
            }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showLine}
                            onChange={(e) => setShowLine(e.target.checked)}
                        />
                    }
                    label="Runoff"
                    sx={{ marginBottom: '0px', marginTop: '0px' }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showBar}
                            onChange={(e) => setShowBar(e.target.checked)}
                        />
                    }
                    label="Rainfall"
                    sx={{ marginBottom: '0px', marginTop: '0px', marginRight: '2px' }}
                />

                {/* <StormDateDropDown /> */}
            </Box>
            <Box sx={{ marginBottom: '0px', marginLeft: '0px', marginTop: '0px' }}>
                <ResponsiveChartContainer
                sx={{
                    //change axis label and line colors
                    "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{
                        fontFamily: "Roboto",
                        },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
                        fill:"#26a6e0"
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-line":{
                        stroke:"#26a6e0",
                        },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tick":{
                        stroke:"#26a6e0",
                        },
                    "& .MuiChartsAxis-left .MuiChartsAxis-label":{
                        fill:"#26a6e0",
                        },
                    "& .MuiChartsAxis-right .MuiChartsAxis-line":{
                        stroke:"rgba(255, 255, 255, 0.5)",
                        },
                    "& .MuiChartsAxis-right .MuiChartsAxis-tick":{
                        stroke:"rgba(255, 255, 255, 0.5)",
                        },
                    "& .MuiChartsAxis-right .MuiChartsAxis-label":{
                        fill:"rgba(255, 255, 255, 0.5)",
                        },
                    "& .MuiChartsAxis-right .MuiChartsAxis-tickLabel":{
                        fill:"rgba(255, 255, 255, 0.5)"
                    },
                }}
                series={series}
                xAxis={[
                    {
                    scaleType: 'band',
                    dataKey: 'time',
                    label: 'Time (hours)',
                    tickInterval: (value, index) => index % 24 === 0,
                    }
                ]}
                yAxis={[
                    { id: 'leftAxis', label: 'Runoff (cfs)' },
                    { id: 'rightAxis', position: 'right', label: 'Rainfall (in)' }
                ]}
                dataset={dataset}
                height={215}
                >
                {showBar && <BarPlot />}
                {showLine && <LinePlot />}
                <ChartsXAxis />
                <ChartsYAxis axisId="leftAxis" />
                <ChartsYAxis axisId="rightAxis" position="right" />
                <ChartsTooltip/>
                {/* <ChartsLegend /> */}
                </ResponsiveChartContainer>
            </Box>
        </Box>
    );
}

export default ResultsChart;